export default function addItemsCount(setItemsCount) {
  return ({ ride, newColumns }) => {
    ride = ride.map((item) => item.items);
    const newItems = {};

    const newRentsItems = [];

    try {
      [...Object.values(ride), ...newColumns]
        .filter((item) => item !== undefined)
        .map((i) => i?.map((e) => newRentsItems.push(e)));

      newRentsItems
        .filter((el) => el)
        .map(
          (i) =>
            (newItems[i.id] = {
              count: (newItems[i.id]?.count || 0) + (i.countInUnit || 1),
              item: i,
            })
        );

      delete newItems.undefined;

      setItemsCount(newItems);
    } catch (e) {
      [Object.values(ride), ...newColumns].map((e) =>
        e
          .filter((el) => el)
          .map(
            (i) =>
              (newItems[i.id] = {
                count: (newItems[i.id]?.count || 0) + (i.countInUnit || 1),
                item: i,
              })
          )
      );

      delete newItems.undefined;

      setItemsCount(newItems);
    }
  };
}
